import { Locale } from 'chaika-enums';
export const supportWidget = {
    supportTitle: {
        [Locale.Ru]: 'Поддержка',
        [Locale.Am]: 'Աջակցություն',
        [Locale.En]: 'Support',
        [Locale.Pt]: 'Suporte',
        [Locale.Ge]: 'მხარდაჭერა',
    },
    supportNewTicket: {
        [Locale.Ru]: 'Новое обращение',
        [Locale.Am]: 'Նոր դիմում',
        [Locale.En]: 'New ticket',
        [Locale.Pt]: 'Novo chamado',
        [Locale.Ge]: 'ახალი მოთხოვნა',
    },
    supportTicketTitlePlaceholder: {
        [Locale.Ru]: 'Тема обращения',
        [Locale.Am]: 'Դիմումի թեման',
        [Locale.En]: 'Ticket subject',
        [Locale.Pt]: 'Assunto do chamado',
        [Locale.Ge]: 'მოთხოვნის თემა',
    },
    supportCreateTicket: {
        [Locale.Ru]: 'Создать',
        [Locale.Am]: 'Ստեղծել',
        [Locale.En]: 'Create',
        [Locale.Pt]: 'Criar',
        [Locale.Ge]: 'შექმნა',
    },
    supportCancel: {
        [Locale.Ru]: 'Отмена',
        [Locale.Am]: 'Չեղարկել',
        [Locale.En]: 'Cancel',
        [Locale.Pt]: 'Cancelar',
        [Locale.Ge]: 'გაუქმება',
    },
    supportClose: {
        [Locale.Ru]: 'Свернуть',
        [Locale.Am]: 'Ծալել',
        [Locale.En]: 'Minimize',
        [Locale.Pt]: 'Minimizar',
        [Locale.Ge]: 'ჩაკეცვა',
    },
    supportBack: {
        [Locale.Ru]: 'К списку обращений',
        [Locale.Am]: 'Վերադառնալ դիմումների ցանկին',
        [Locale.En]: 'Back to tickets',
        [Locale.Pt]: 'Voltar aos chamados',
        [Locale.Ge]: 'მოთხოვნების სიაში დაბრუნება',
    },
    supportStatusDeleted: {
        [Locale.Ru]: 'Обращение удалено',
        [Locale.Am]: 'Դիմումը ջնջված է',
        [Locale.En]: 'Ticket deleted',
        [Locale.Pt]: 'Chamado excluído',
        [Locale.Ge]: 'მოთხოვნა წაშლილია',
    },
    supportResponsible: {
        [Locale.Ru]: 'Ответственный: $name',
        [Locale.Am]: 'Պատասխանատու՝ $name',
        [Locale.En]: 'Responsible: $name',
        [Locale.Pt]: 'Responsável: $name',
        [Locale.Ge]: 'პასუხისმგებელი: $name',
    },
    supportMessagePlaceholder: {
        [Locale.Ru]: 'Напишите сообщение',
        [Locale.Am]: 'Գրեք հաղորդագրություն',
        [Locale.En]: 'Write a message',
        [Locale.Pt]: 'Escreva uma mensagem',
        [Locale.Ge]: 'დაწერეთ შეტყობინება',
    },
    supportRemoveAttachment: {
        [Locale.Ru]: 'Удалить вложение $name',
        [Locale.Am]: 'Հեռացնել $name կցորդը',
        [Locale.En]: 'Remove attachment $name',
        [Locale.Pt]: 'Remover anexo $name',
        [Locale.Ge]: '$name დანართის წაშლა',
    },
    supportDeletedExplanation: {
        [Locale.Ru]: 'Обращение удалено в службе поддержки',
        [Locale.Am]: 'Դիմումը ջնջվել է աջակցության ծառայությունում',
        [Locale.En]: 'The ticket was deleted in support',
        [Locale.Pt]: 'O chamado foi excluído no suporte',
        [Locale.Ge]: 'მოთხოვნა მხარდაჭერის სამსახურში წაიშალა',
    },
    supportAttachmentLimit: {
        [Locale.Ru]: 'Можно прикрепить не больше 20 файлов',
        [Locale.Am]: 'Կարելի է կցել ոչ ավելի, քան 20 ֆայլ',
        [Locale.En]: 'You can attach no more than 20 files',
        [Locale.Pt]: 'É possível anexar no máximo 20 arquivos',
        [Locale.Ge]: 'შეგიძლიათ მიამაგროთ არაუმეტეს 20 ფაილი',
    },
    supportAttachmentTooLarge: {
        [Locale.Ru]: 'Файл больше 20 МБ',
        [Locale.Am]: 'Ֆայլը 20 ՄԲ-ից մեծ է',
        [Locale.En]: 'File is larger than 20 MB',
        [Locale.Pt]: 'Arquivo maior que 20 MB',
        [Locale.Ge]: 'ფაილი 20 მბ-ზე დიდია',
    },
    supportAttachmentInvalid: {
        [Locale.Ru]: 'Загрузите файл ещё раз',
        [Locale.Am]: 'Վերբեռնեք ֆայլը ևս մեկ անգամ',
        [Locale.En]: 'Upload the file again',
        [Locale.Pt]: 'Envie o arquivo novamente',
        [Locale.Ge]: 'ატვირთეთ ფაილი ხელახლა',
    },
    supportAttachmentUploadFailed: {
        [Locale.Ru]: 'Не удалось загрузить файл. Попробуйте ещё раз.',
        [Locale.Am]: 'Չհաջողվեց վերբեռնել ֆայլը։ Փորձեք կրկին։',
        [Locale.En]: 'The file could not be uploaded. Try again.',
        [Locale.Pt]: 'Não foi possível enviar o arquivo. Tente novamente.',
        [Locale.Ge]: 'ფაილის ატვირთვა ვერ მოხერხდა. სცადეთ ხელახლა.',
    },
    supportEdited: {
        [Locale.Ru]: 'изменено',
        [Locale.Am]: 'խմբագրված',
        [Locale.En]: 'edited',
        [Locale.Pt]: 'editado',
        [Locale.Ge]: 'რედაქტირებულია',
    },
    supportUnreadCount: {
        [Locale.Ru]: 'Непрочитанных сообщений: $count',
        [Locale.Am]: 'Չընթերցված հաղորդագրություններ՝ $count',
        [Locale.En]: 'Unread messages: $count',
        [Locale.Pt]: 'Mensagens não lidas: $count',
        [Locale.Ge]: 'წაუკითხავი შეტყობინებები: $count',
    },
    supportLoadMore: {
        [Locale.Ru]: 'Показать ещё',
        [Locale.Am]: 'Ցույց տալ ավելին',
        [Locale.En]: 'Show more',
        [Locale.Pt]: 'Mostrar mais',
        [Locale.Ge]: 'მეტის ჩვენება',
    },
    supportLoadOlderMessages: {
        [Locale.Ru]: 'Показать предыдущие сообщения',
        [Locale.Am]: 'Ցույց տալ նախորդ հաղորդագրությունները',
        [Locale.En]: 'Show previous messages',
        [Locale.Pt]: 'Mostrar mensagens anteriores',
        [Locale.Ge]: 'წინა შეტყობინებების ჩვენება',
    },
    supportLoading: {
        [Locale.Ru]: 'Загрузка…',
        [Locale.Am]: 'Բեռնում…',
        [Locale.En]: 'Loading…',
        [Locale.Pt]: 'Carregando…',
        [Locale.Ge]: 'იტვირთება…',
    },
    supportEmptyTickets: {
        [Locale.Ru]: 'Обращений пока нет',
        [Locale.Am]: 'Դիմումներ դեռ չկան',
        [Locale.En]: 'No tickets yet',
        [Locale.Pt]: 'Ainda não há chamados',
        [Locale.Ge]: 'მოთხოვნები ჯერ არ არის',
    },
    supportEmptyMessages: {
        [Locale.Ru]: 'Сообщений пока нет',
        [Locale.Am]: 'Հաղորդագրություններ դեռ չկան',
        [Locale.En]: 'No messages yet',
        [Locale.Pt]: 'Ainda não há mensagens',
        [Locale.Ge]: 'შეტყობინებები ჯერ არ არის',
    },
    supportError: {
        [Locale.Ru]: 'Не удалось загрузить данные. Попробуйте ещё раз.',
        [Locale.Am]: 'Չհաջողվեց բեռնել տվյալները։ Փորձեք կրկին։',
        [Locale.En]: 'Could not load data. Please try again.',
        [Locale.Pt]: 'Não foi possível carregar os dados. Tente novamente.',
        [Locale.Ge]: 'მონაცემების ჩატვირთვა ვერ მოხერხდა. სცადეთ ხელახლა.',
    },
    supportAccessRemoved: {
        [Locale.Ru]: 'Обращение больше недоступно. Вы вернулись к списку обращений.',
        [Locale.Am]: 'Դիմումն այլևս հասանելի չէ։ Դուք վերադարձել եք դիմումների ցանկին։',
        [Locale.En]: 'This ticket is no longer available. You have returned to the ticket list.',
        [Locale.Pt]: 'Este chamado não está mais disponível. Você voltou à lista de chamados.',
        [Locale.Ge]: 'ეს მოთხოვნა აღარ არის ხელმისაწვდომი. თქვენ დაბრუნდით მოთხოვნების სიაში.',
    },
    supportAuthorizationRequired: {
        [Locale.Ru]: 'Для подключения к поддержке войдите в МИС заново.',
        [Locale.Am]: 'Աջակցությանը միանալու համար կրկին մուտք գործեք համակարգ։',
        [Locale.En]: 'Please sign in again to connect to support.',
        [Locale.Pt]: 'Entre novamente para se conectar ao suporte.',
        [Locale.Ge]: 'მხარდაჭერასთან დასაკავშირებლად ხელახლა შედით სისტემაში.',
    },
    supportSendError: {
        [Locale.Ru]: 'Не удалось подтвердить отправку. Проверьте переписку перед повторной отправкой.',
        [Locale.Am]: 'Չհաջողվեց հաստատել ուղարկումը։ Կրկին ուղարկելուց առաջ ստուգեք նամակագրությունը։',
        [Locale.En]: 'Sending could not be confirmed. Check the conversation before sending again.',
        [Locale.Pt]: 'Não foi possível confirmar o envio. Verifique a conversa antes de enviar novamente.',
        [Locale.Ge]: 'გაგზავნა ვერ დადასტურდა. ხელახლა გაგზავნამდე შეამოწმეთ მიმოწერა.',
    },
    supportSending: {
        [Locale.Ru]: 'Отправляется…',
        [Locale.Am]: 'Ուղարկվում է…',
        [Locale.En]: 'Sending…',
        [Locale.Pt]: 'Enviando…',
        [Locale.Ge]: 'იგზავნება…',
    },
    supportSendFailed: {
        [Locale.Ru]: 'Не отправлено',
        [Locale.Am]: 'Չի ուղարկվել',
        [Locale.En]: 'Not sent',
        [Locale.Pt]: 'Não enviado',
        [Locale.Ge]: 'არ გაიგზავნა',
    },
    supportRetrySend: {
        [Locale.Ru]: 'Отправить ещё раз',
        [Locale.Am]: 'Կրկին ուղարկել',
        [Locale.En]: 'Send again',
        [Locale.Pt]: 'Enviar novamente',
        [Locale.Ge]: 'ხელახლა გაგზავნა',
    },
    supportResponsibleNotAssigned: {
        [Locale.Ru]: 'Ответственный не назначен',
        [Locale.Am]: 'Պատասխանատու նշանակված չէ',
        [Locale.En]: 'No assignee',
        [Locale.Pt]: 'Responsável não atribuído',
        [Locale.Ge]: 'პასუხისმგებელი არ არის დანიშნული',
    },
    supportParticipantsCount: {
        [Locale.Ru]: 'Участники: $count',
        [Locale.Am]: 'Մասնակիցներ՝ $count',
        [Locale.En]: 'Participants: $count',
        [Locale.Pt]: 'Participantes: $count',
        [Locale.Ge]: 'მონაწილეები: $count',
    },
    supportParticipantsList: {
        [Locale.Ru]: 'Участники обращения',
        [Locale.Am]: 'Դիմումի մասնակիցներ',
        [Locale.En]: 'Ticket participants',
        [Locale.Pt]: 'Participantes do chamado',
        [Locale.Ge]: 'მოთხოვნის მონაწილეები',
    },
    supportParticipantYou: {
        [Locale.Ru]: '(вы)',
        [Locale.Am]: '(դուք)',
        [Locale.En]: '(you)',
        [Locale.Pt]: '(você)',
        [Locale.Ge]: '(თქვენ)',
    },
    supportSearchPlaceholder: {
        [Locale.Ru]: 'Поиск по названию или номеру',
        [Locale.Am]: 'Որոնում ըստ անվանման կամ համարի',
        [Locale.En]: 'Search by title or number',
        [Locale.Pt]: 'Pesquisar por título ou número',
        [Locale.Ge]: 'ძიება სათაურით ან ნომრით',
    },
    supportSearchClear: {
        [Locale.Ru]: 'Очистить',
        [Locale.Am]: 'Մաքրել',
        [Locale.En]: 'Clear',
        [Locale.Pt]: 'Limpar',
        [Locale.Ge]: 'გასუფთავება',
    },
    supportFilterLabel: {
        [Locale.Ru]: 'Фильтр по статусу',
        [Locale.Am]: 'Զտիչ ըստ կարգավիճակի',
        [Locale.En]: 'Status filter',
        [Locale.Pt]: 'Filtro por status',
        [Locale.Ge]: 'სტატუსის ფილტრი',
    },
    supportFilterOpenOnly: {
        [Locale.Ru]: 'Только открытые',
        [Locale.Am]: 'Միայն բացերը',
        [Locale.En]: 'Open only',
        [Locale.Pt]: 'Somente abertos',
        [Locale.Ge]: 'მხოლოდ ღია',
    },
    supportFilterAllStatuses: {
        [Locale.Ru]: 'Все статусы',
        [Locale.Am]: 'Բոլոր կարգավիճակները',
        [Locale.En]: 'All statuses',
        [Locale.Pt]: 'Todos os status',
        [Locale.Ge]: 'ყველა სტატუსი',
    },
    supportFilterStatusesCount: {
        [Locale.Ru]: 'Статусы: $count',
        [Locale.Am]: 'Կարգավիճակներ՝ $count',
        [Locale.En]: 'Statuses: $count',
        [Locale.Pt]: 'Status: $count',
        [Locale.Ge]: 'სტატუსები: $count',
    },
    supportFilterReset: {
        [Locale.Ru]: 'Сбросить',
        [Locale.Am]: 'Վերակայել',
        [Locale.En]: 'Reset',
        [Locale.Pt]: 'Redefinir',
        [Locale.Ge]: 'გადაყენება',
    },
    supportEmptyOpenTickets: {
        [Locale.Ru]: 'Нет открытых обращений',
        [Locale.Am]: 'Բաց դիմումներ չկան',
        [Locale.En]: 'No open tickets',
        [Locale.Pt]: 'Nenhum chamado aberto',
        [Locale.Ge]: 'ღია მოთხოვნები არ არის',
    },
    supportShowAllTickets: {
        [Locale.Ru]: 'Показать все',
        [Locale.Am]: 'Ցույց տալ բոլորը',
        [Locale.En]: 'Show all',
        [Locale.Pt]: 'Mostrar todos',
        [Locale.Ge]: 'ყველას ჩვენება',
    },
    supportEmptyFilteredTickets: {
        [Locale.Ru]: 'Нет обращений с выбранными статусами',
        [Locale.Am]: 'Ընտրված կարգավիճակներով դիմումներ չկան',
        [Locale.En]: 'No tickets with the selected statuses',
        [Locale.Pt]: 'Nenhum chamado com os status selecionados',
        [Locale.Ge]: 'არჩეული სტატუსებით მოთხოვნები არ არის',
    },
    supportNothingFound: {
        [Locale.Ru]: 'Ничего не найдено',
        [Locale.Am]: 'Ոչինչ չի գտնվել',
        [Locale.En]: 'Nothing found',
        [Locale.Pt]: 'Nada encontrado',
        [Locale.Ge]: 'ვერაფერი მოიძებნა',
    },
    supportAttachFile: {
        [Locale.Ru]: 'Прикрепить файл',
        [Locale.Am]: 'Կցել ֆայլ',
        [Locale.En]: 'Attach file',
        [Locale.Pt]: 'Anexar arquivo',
        [Locale.Ge]: 'ფაილის მიმაგრება',
    },
    supportEmoji: {
        [Locale.Ru]: 'Эмодзи',
        [Locale.Am]: 'Էմոջի',
        [Locale.En]: 'Emoji',
        [Locale.Pt]: 'Emoji',
        [Locale.Ge]: 'ემოჯი',
    },
    supportSend: {
        [Locale.Ru]: 'Отправить',
        [Locale.Am]: 'Ուղարկել',
        [Locale.En]: 'Send',
        [Locale.Pt]: 'Enviar',
        [Locale.Ge]: 'გაგზავნა',
    },
    supportAttachmentRemove: {
        [Locale.Ru]: 'Удалить',
        [Locale.Am]: 'Ջնջել',
        [Locale.En]: 'Remove',
        [Locale.Pt]: 'Remover',
        [Locale.Ge]: 'წაშლა',
    },
    supportAttachmentRetry: {
        [Locale.Ru]: 'Повторить',
        [Locale.Am]: 'Կրկնել',
        [Locale.En]: 'Retry',
        [Locale.Pt]: 'Tentar novamente',
        [Locale.Ge]: 'გამეორება',
    },
    supportFileSizeBytes: {
        [Locale.Ru]: '$size Б',
        [Locale.Am]: '$size Բ',
        [Locale.En]: '$size B',
        [Locale.Pt]: '$size B',
        [Locale.Ge]: '$size ბ',
    },
    supportFileSizeKilobytes: {
        [Locale.Ru]: '$size КБ',
        [Locale.Am]: '$size ԿԲ',
        [Locale.En]: '$size KB',
        [Locale.Pt]: '$size KB',
        [Locale.Ge]: '$size კბ',
    },
    supportFileSizeMegabytes: {
        [Locale.Ru]: '$size МБ',
        [Locale.Am]: '$size ՄԲ',
        [Locale.En]: '$size MB',
        [Locale.Pt]: '$size MB',
        [Locale.Ge]: '$size მბ',
    },
};
